var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0392 1.39188C15.645 0.785957 16.4586 0.43311 17.3149 0.404907C18.1712 0.376703 19.0063 0.675254 19.6506 1.24001L19.8126 1.39188L20.608 2.18726C21.2136 2.79298 21.5662 3.60631 21.5944 4.46239C21.6226 5.31847 21.3243 6.15324 20.7598 6.79751L20.608 6.95951L7.99446 19.5741C7.81612 19.7525 7.60007 19.8885 7.36221 19.9724L7.17996 20.0253L2.16921 21.1818C1.99367 21.2223 1.81096 21.2202 1.63642 21.1755C1.46189 21.1308 1.30061 21.0449 1.16615 20.925C1.03169 20.8051 0.927961 20.6547 0.863676 20.4864C0.799391 20.3181 0.776427 20.1368 0.796711 19.9578L0.819211 19.8306L1.97459 14.8188C2.03166 14.5729 2.14315 14.343 2.30084 14.146L2.42571 14.0054L15.0392 1.39188ZM14.2438 5.36876L4.13009 15.4825L3.41459 18.5853L6.51734 17.8686L16.6311 7.75488L14.2438 5.36876ZM18.2218 2.98263C18.0281 2.78894 17.7704 2.67258 17.497 2.65538C17.2236 2.63819 16.9533 2.72135 16.7368 2.88926L16.6311 2.98263L15.8346 3.77801L18.2218 6.16413L19.0172 5.36876C19.2109 5.17504 19.3273 4.9173 19.3445 4.6439C19.3617 4.3705 19.2785 4.10021 19.1106 3.88376L19.0172 3.77801L18.2218 2.98263Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.8df9c16bff225b0c94608803341893b3.svg";
export { ForwardRef as ReactComponent };